import React from 'react';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <footer className="bg-gradient-to-r from-slate-900 to-slate-800 text-slate-400 py-11 mt-auto border-t border-slate-700/50">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
          {/* Left side: Navigation Links */}
          <div className="flex flex-wrap justify-center lg:justify-start gap-6">
            <button
              onClick={() => handleNavigation('/change-logs')}
              className="group flex items-center text-sm font-medium text-slate-300 hover:text-white transition-all duration-300 hover:scale-105"
            >
              <span className="px-2 py-1 bg-blue-500/20 rounded-lg text-blue-300 font-mono text-xs mr-2 group-hover:bg-blue-500/30 transition-colors">
                v2.0-alpha.1
              </span>
              <span className="border-b border-transparent group-hover:border-blue-400 transition-all">
                Change Logs
              </span>
            </button>
            
            <button
              onClick={() => handleNavigation('/api-reference')}
              className="group flex items-center text-sm font-medium text-slate-300 hover:text-white transition-all duration-300 hover:scale-105"
            >
              <svg className="w-4 h-4 mr-2 text-slate-400 group-hover:text-green-400 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
              </svg>
              <span className="border-b border-transparent group-hover:border-green-400 transition-all">
                API Reference
              </span>
            </button>
            
            <button
              onClick={() => handleNavigation('/provide-feedback')}
              className="group flex items-center text-sm font-medium text-slate-300 hover:text-white transition-all duration-300 hover:scale-105"
            >
              <svg className="w-4 h-4 mr-2 text-slate-400 group-hover:text-purple-400 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
              </svg>
              <span className="border-b border-transparent group-hover:border-purple-400 transition-all">
                Provide Feedback
              </span>
            </button>
          </div>

          {/* Right side: Copyright */}
          <div className="text-sm text-slate-400 text-center lg:text-right">
            <div className="flex items-center space-x-2">
              <svg className="w-4 h-4 text-slate-500" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/>
              </svg>
              <span>&copy; 2025 Advanced Medical Access Philippines (AMAPHIL) Inc. All Rights Reserved</span>
            </div>
          </div>
        </div>

        {/* Bottom: Additional Info */}
        <div className="mt-4 pt-4 border-t border-slate-700/30 text-center">
          <p className="text-xs text-slate-500">
            Built with modern healthcare technology • Secure • HIPAA Compliant
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;